import { ArrowUpOnSquareIcon } from '@heroicons/react/24/solid';
import React, { useEffect, useState } from 'react';
import { apiCall } from '../../../api/Interactor';
import { containsOnlyNumbers, showToast, timeFormatNonUTC } from '../../../Utils';
import { useParams } from 'react-router-dom';
import { useAppState } from '../../../AppStateContext';
import { Tabs, Tab } from "../../Tabs";
import { Switch } from '@headlessui/react';
import { CalendarDaysIcon, ClockIcon, PlusCircleIcon, XMarkIcon, TrashIcon } from '@heroicons/react/20/solid';
import classNames from 'classnames';
import { format } from 'date-fns';
import DatePickerDialog from '../DatePickerDialog';
import ScheduleVenueDialog from '../ScheduleVenueDialog';
import MapDialog from '../MapDialog';
import { createVenue, editVenue, getVenueDetail } from '../../../api/VenueInteractor';
import AddScheduleVenueDialog from '../AddScheduleVenueDialog'
import DaySelectionDialog from '../dialog/DaySelectionDialog'
import TimeSelectionDialog from '../dialog/TimeSelectionDialog'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import InputMask from 'react-input-mask';

const inputClass = "w-full text-xs bg-[#F5F5F5] rounded-lg py-2.5 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"
const textarea = "w-full h-36 text-xs bg-[#F5F5F5] rounded-lg py-2 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"


export default function Company(props) {

  const { user, updateUser } = useAppState();

  const inputClass = "w-full text-xs bg-[#F5F5F5] rounded-md py-2 px-6 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow"

  const [loading, setLoading] = useState(false)



  //venue image
  const [venueImage, setVenueImage] = useState(null)
  const [venueImageUrl, setVenueImageUrl] = useState(null)

  //venue attachments
  const [attachments, setAttachments] = useState([])
  const [attachmentsUrl, setAttachmentsUrl] = useState([])

  const hiddenFileInput = React.useRef(null);
  const attachmentsRef = React.useRef(null);



  const addOnList = [
    {
      id: "0",
      name: "Jual Makanan & Minuman",
      image: "/facilities/ic-jual-makanan-&-minuman.svg"
    },
    {
      id: "1",
      name: "WIFI",
      image: "/facilities/ic-wifi.svg"

    },
    {
      id: "2",
      name: "Toilet",
      image: "/facilities/ic-toilet.svg"
    },
    {
      id: "3",
      name: "Parkir Motor",
      image: "/facilities/ic-parkir-motor.svg"
    },
    {
      id: "4",
      name: "Musholla",
      image: "/facilities/ic-musholla.svg"
    },
    {
      id: "5",
      name: "Parkir Mobil",
      image: "/facilities/ic-parkir-mobil.svg"
    },
    {
      id: "6",
      name: "Tribun",
      image: "/facilities/ic-tribun.svg"
    },
    {
      id: "7",
      name: "Hot Shower",
      image: "/facilities/ic-hot-shower.svg"
    },
    {
      id: "8",
      name: "Ruang Ganti",
      image: "/facilities/ic-ruang-ganti.svg"
    },
  ]


  const [selectedAddOns, setselectedAddOns] = useState([])

  //venue form 
  const [venueId, setVenueId] = useState(null)
  const [venueName, setVenueName] = useState("")
  const [venueType, setVenueType] = useState("Padel")
  const [venueDesc, setVenueDesc] = useState("")
  const [venueLat, setVenueLat] = useState("")
  const [venueLong, setVenueLong] = useState("")
  const [venueAddress, setVenueAddress] = useState("")
  const [venueGeocodeAddress, setVenueGeocodeAddress] = useState("")
  const [venueDayOfService, setVenueDayOfService] = useState("")
  const [venueOpenHour, setVenueOpenHour] = useState("")
  const [venueCloseHour, setVenueCloseHour] = useState("")
  const [venueIsDp, setVenueIsDp] = useState(false)
  const [venueMinimalDp, setVenueMinimalDp] = useState(0)
  const [venueTos, setVenueTos] = useState("")
  const [venueFacility, setVenueFacility] = useState("")


  const [dayOpen, setDayOpen] = useState([{
    day: "Senin",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Selasa",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Rabu",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Kamis",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Jumat",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Sabtu",
    checked: false,
    service_times_attributes: []
  }, {
    day: "Minggu",
    checked: false,
    service_times_attributes: []
  }])

  // let [company, setCompany] = useState({
  //   icon: null,
  //   iconUrl: "",
  //   name: "",
  //   city: ""
  // })

  let [userData, setUserData] = useState({
    name: user.name,
    phone_number: user.phone_number,
    email: user.email,
    password: "",
    ulangi_password: ""
  })

  let [profile, setProfile] = useState({
    bank: "",
    name: "",
    number: "",
  })



  const handleAddress = (lat, lng, address) => {

    setVenueLat(lat)
    setVenueLong(lng)
    setVenueGeocodeAddress(address)

  }


  const onAddOnSelected = (addOn) => {
    const selectedAddOnsTemp = [...selectedAddOns]
    const existIndex = selectedAddOnsTemp.findIndex(e => e.name == addOn.name)

    if (existIndex >= 0) {

      selectedAddOnsTemp.splice(existIndex, 1)

    } else {
      selectedAddOnsTemp.push(addOn)
    }

    setselectedAddOns(selectedAddOnsTemp)

  }


  const checkAddon = (addOn) => {
    const result = (selectedAddOns.length > 0) && (selectedAddOns.filter((e) => e.name == addOn.name).length > 0)

    return result
  }

  const handleAttachmentClick = event => {
    attachmentsRef.current.click();
  };

  const onAttachmentChange = (event) => {
    let urlTemp = []
    setAttachments(event.target.files)
    for (let i = 0; i < event.target.files.length; i++) {
      urlTemp.push(URL.createObjectURL(event.target.files[i]))
    }
    setAttachmentsUrl(urlTemp);
  }

  const onFileChange = (event) => {
    setVenueImage(event.target.files[0])
    setVenueImageUrl(URL.createObjectURL(event.target.files[0]));
  }

  const onBackgroundChange = (event) => {
    setVenueImage(event.target.files[0])
    setVenueImageUrl(URL.createObjectURL(event.target.files[0]));
  }

  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  useEffect(() => {
      const selectedDays = dayOpen.filter(day => day.checked).map(day => day.day);
      // if (selectedDays.length === 0) return "Pilih hari...";
      const indices = selectedDays.map((day) => {
        return dayOpen.findIndex((d) => d.day === day);
      });
      indices.sort((a, b) => a - b);
  
      // // Check if the selected days are consecutive
      const isConsecutive = indices.every((val, i, arr) => i === 0 || val - arr[i - 1] === 1);
  
      if (isConsecutive) {
        updateDayOfService(`${selectedDays[0]} - ${selectedDays[selectedDays.length - 1]}`);
      } else {
        updateDayOfService(selectedDays.join(", "));
      }
    }, [dayOpen])


  const updateDayOfService = (day_of_service) => {
    if (day_of_service !== "") {
      // const dayStart = day_of_service.split("-")[0].trim()
      // const dayEnd = day_of_service.split("-")[1].trim()
      const dayStart = "Senin"
      const dayEnd = "Minggu"
      let tmpDayOpen = [...dayOpen]
      let checked = false
      tmpDayOpen.forEach(item => {
        if (item.day === dayStart) {
          checked = true
        }
        item.checked = checked
        if (item.day === dayEnd) {
          checked = false
        }
      });
      console.log("day_of_service")
      console.log(day_of_service)
      setVenueDayOfService(day_of_service)
      setDayOpen(tmpDayOpen)
    }
  }



  const updateUserAdmin = () => {
    if (userData.password === "") {
      return
    } else if (userData.password !== userData.ulangi_password) {
      showToast("Error", "Failed", "Password tidak sesuai")
      return
    }

    setLoading(true)
    apiCall(
      "PUT", process.env.REACT_APP_USER_ADMIN + "/" + user.id,
      {
        auth_token: user.auth_token,
        user_admin: {
          name: userData.name,
          phone_number: userData.phone_number,
          email: userData.email,
          password: userData.password,
          password_confirmation: userData.ulangi_password
        }
      },
      (response) => {
        setLoading(false)
        console.log(response)
        showToast("Success", "Success", response.data.meta.message)
      },
      (message) => {
        setLoading(false)
        showToast("Error", "Failed", message)
      }
    )
  }


  const updateCompanyApi = () => {
    setLoading(true)
    let method = "POST"
    let url = process.env.REACT_APP_VENUE
    if (venueId !== null) {
      method = "PUT"
      url = process.env.REACT_APP_VENUE + "/" + user.id
    }
    const formData = new FormData();
    // if (company.icon) {
    //   formData.append("[company][logo]", company.icon);
    // }
    formData.append("[company][name]", venueName);
    formData.append("[company][venue_name]", venueName);
    formData.append("[company][sport_type]", venueType)
    // formData.append("[company][city]", company.city);
    formData.append("[company][location]", venueAddress);
    formData.append("[company][description]", venueDesc);
    if (venueLat !== "" && venueLong !== "") {
      formData.append("[company][latitude]", venueLat);
      formData.append("[company][longitude]", venueLong);
    }
    if (attachments.length > 0) {
      const temp1 = [...attachments]
      temp1.forEach((element, i) => {
        formData.append("[service_images][image_name][]", element)
      });
    }
    if (venueImage) {
      formData.append("[company][cover]", venueImage)
    }
    formData.append("[company][day_of_service]", venueDayOfService)
    formData.append("[company][open_hour]", venueOpenHour)
    formData.append("[company][close_hour]", venueCloseHour)
    formData.append("[company][terms_of_service]", venueTos)
    let facility = ""
    selectedAddOns.forEach(element => {
      facility = facility + element.name + ", "
    });

    formData.append("[company][facilities]", facility)

    apiCall(
      method, url,
      formData,
      (response) => {
        setLoading(false)
        console.log(response)
        let data = response.data.data
        showToast("Success", "Success", response.data.meta.message)
      },
      (message) => {
        setLoading(false)
        showToast("Error", "Failed", message)
      }
    )
  }

  const updateProfileApi = () => {
    setLoading(true)
    let method = "POST"
    let url = process.env.REACT_APP_USER_PROFILES
    let requestProfile = {
      bank_account_number: profile.number,
      bank_name: profile.bank + " - " + profile.name
    }
    if (profile.id !== undefined) {
      method = "PATCH"
      url = process.env.REACT_APP_USER_PROFILES_MULTIPLE
      requestProfile.id = profile.id
    }
    let requestData = {
      // auth_token: user.auth_token,
      profiles: [
        requestProfile
      ]
    }
    apiCall(
      method, url,
      requestData,
      (response) => {
        setLoading(false)
        console.log(response)
        showToast("Success", "Success", response.data.meta.message)
      },
      (message) => {
        setLoading(false)
      }
    )
  }

  const getDetailsCompanyApi = () => {
    apiCall(
      "GET", process.env.REACT_APP_USER_COMPANY,
      {

      },
      (response) => {
        console.log(response)
        let responseJSON = response.data.data

        setVenueOpenHour(timeFormatNonUTC(responseJSON.open_hour))
        setVenueCloseHour(timeFormatNonUTC(responseJSON.close_hour))
        setVenueDayOfService(responseJSON.day_of_service)
        updateDayOfService(responseJSON.day_of_service)
        setVenueDesc(responseJSON.description)

        //facility
        let temp = responseJSON.facilities.split(",")
        let temp2 = []
        //iterate to remove space
        temp.forEach((item) => {
          temp2.push({
            name: item.replace(/\s+/g, ' ').trim()
          })
        })

        //remove empty item
        let index = temp2.findIndex((item) => { return item == "" })


        if (index > 0) {
          temp2.splice(index, 1)
        }
        setselectedAddOns(temp2)

        setVenueImageUrl(process.env.REACT_APP_BASE_URL_IMAGE + "/" + responseJSON.cover.url)
        setVenueAddress(responseJSON.location)
        setVenueId(responseJSON.id)
        setVenueName(responseJSON.name)
        setVenueType(responseJSON.sport_type)
        setVenueLat(responseJSON.latitude)
        setVenueLong(responseJSON.longitude)

        let url = []
        responseJSON.service_images.forEach((item) => {
          url.push(process.env.REACT_APP_BASE_URL_IMAGE + "/" + item.image_name.url)
        })
        setAttachmentsUrl(url)
        setVenueTos(responseJSON.terms_of_service)
      },
      (message) => {
      }
    )
  }

  const getProfilesApi = () => {
    apiCall(
      "GET", process.env.REACT_APP_USER_PROFILES,
      {

      },
      (response) => {
        console.log(response)
        let data = response.data.data
        console.log("Profiles")
        console.log(data)
        if (data.length > 0) {
          let item = data[0];
          setProfile(prev => ({
            ...prev,
            id: item.id,
            bank: item.bank_name.split(" - ")[0],
            name: item.bank_name.split(" - ")[1],
            number: item.bank_account_number
          }))
          console.log("Profile")
          console.log(item);
        }
      },
      (message) => {
        showToast("Error", "Failed", message)
      }
    )
  }

  useEffect(() => {
    getDetailsCompanyApi()
    getProfilesApi()
  }, [])


  return (
    <div className=' w-full bg-white rounded-2xl flex flex-col px-6 py-6'>
      <p className='text-lg my-4 text-left text-gray-800 font-semibold'>Pengaturan</p>


      <div className='flex-1 rounded-lg border-2'>

        <Tabs>
          <Tab label="Detail Lapang">
            <div className="p-4">
              {/* <div className='flex flex-col lg:flex-row w-full lg:gap-x-5 gap-y-5'>

                <div className='lg:w-7/12 w-full flex flex-col gap-y-5 py-5 px-5 gap-y-5 '>
                  <div className='flex w-full gap-x-4'>
                    <input onChange={(e) => {
                      setVenueName(e.target.value)
                    }} value={venueName} type="text" className={"w-1/2 text-[10px] " + inputClass} placeholder='Nama Company' />
                    <input onChange={(e) => {
                      setCompany(prev => ({
                        ...prev,
                        city: e.target.value,
                      }))
                    }} value={company.city} type="text" className={"w-1/2 text-[10px] " + inputClass} placeholder='City' />
                  </div>
                  <div className='lg:w-6/12 w-full flex flex-col py-4 px-4 gap-y-2 items-center rounded-lg border-2 border-gray-200 border-dashed '>

                    {company.iconUrl == "" ?
                      <img src='/ic_img.png' className='w-14' />
                      :
                      <img src={company.iconUrl} className='w-24' />
                    }


                    <p className='text-sm  text-left text-gray-800 font-semibold'>Logo Perusahaan</p>
                    <p className='text-[10px]  text-center text-gray-500 font-semibold'>Besar file: maksimum 10.000.000 bytes (10 Megabytes).
                      Ekstensi file yang diperbolehkan: .JPG .JPEG .PNG</p>


                    <input id="file-upload"
                      ref={hiddenFileInput}
                      onChange={(e) => { onFileChange(e) }}
                      name="file-upload" type="file" class="sr-only" />
                    <button onClick={handleClick} className='flex mt-2 items-center px-6 py-2 text-[10px] font-semibold text-white bg-primaryRed rounded-md'>
                      <ArrowUpOnSquareIcon className='w-5 mr-2' />
                      Update Logo
                    </button>

                  </div>
                </div>

              </div> */}

              {/* detail lapangan  */}
              <div className='relative flex flex-col border border-gray-300 rounded-lg overflow-hidden pt-12 gap-x-6 px-8 pb-6'>

                <p className='absolute left-0 top-0 px-3 bg-gray-200 py-1.5 rounded-br-lg text-sm font-semibold '>Detail Lapang</p>

                {/* background  */}
                <div className='flex border mb-6 border-gray-300 border-dashed rounded-lg items-start'>

                  <div className="w-full px-4 py-4 relative flex flex-col gap-y-2 items-center bg-cover bg-center bg-no-repeat">
                    {/* style={{backgroundImage: `url(${venueImageUrl})`}} >*/}

                    {/* Change Background Button (top-right corner) */}
                    {/* <button
                      onClick={handleClick}
                      className="absolute right-4 px-3 py-1 text-xs bg-black bg-opacity-50 text-white rounded hover:bg-opacity-70"
                    >
                      Change Background
                    </button> */}

                    {/* Logo Display */}
                    {venueImageUrl === "" ? (
                      <img src="/ic_img.png" className="h-[200px] mt-4" alt="Default Logo" />
                    ) : (
                      <img src={venueImageUrl} className="h-[200px] mt-4" alt="Venue Logo" />
                    )}

                    <p className="text-sm text-left text-gray-800 font-semibold">Background Venue</p>
                    <p className="text-[10px] text-center text-gray-500 font-semibold">
                      Besar file maksimum 10 Mb, dan ekstensi file yang diperbolehkan: .JPG .JPEG .PNG
                    </p>

                    <input
                      id="file-upload"
                      ref={hiddenFileInput}
                      onChange={(e) => { onFileChange(e); }}
                      name="file-upload"
                      type="file"
                      className="sr-only"
                    />

                    <button
                      onClick={handleClick}
                      className="flex mt-2 mb-4 items-center px-6 py-2 text-[10px] font-semibold text-white bg-primaryRed rounded-md"
                    >
                      <ArrowUpOnSquareIcon className="w-5 mr-2" />
                      Update Background Venue
                    </button>
                  </div>


                  {/* <div className='flex flex-col items-center w-5/12'>
                    {venueImageUrl == null ?
                      <>
                        <img src='/ic_img.png' className='w-16' />
                        <p className='text-sm font-semibold text-gray-800 mt-4'>Background Cover</p>
                      </> :
                      <img src={venueImageUrl} className='w-[140px] rounded-lg ' />

                    }

                  </div>

                  <div className='flex flex-col w-7/12 items-start '>

                    <p className='text-xs font-semibold text-gray-400'>Ukuran disarankan 1000 x 326px</p>


                    <input id="file-upload"
                      ref={hiddenFileInput}
                      onChange={(e) => { onFileChange(e) }}
                      name="file-upload" type="file" className="sr-only" />
                    <button onClick={handleClick} className='w-full w-fit flex mt-4 items-center bg-primaryRed rounded-lg text-xs font-semibold text-white justify-center py-2.5 px-4'>
                      <ArrowUpOnSquareIcon className='w-4 mr-2' />
                      Unggah Background
                    </button>

                  </div> */}

                </div>
                <div className='flex gap-x-6 w-full '>

                  {/* detail lapangan part kiri  */}
                  <div className='flex flex-col w-1/2  gap-y-6 '>

                    {/* <div className='flex w-full justify-start mt-4 px-4 py-2 rounded-lg text-xs bg-gray-100'>
                      <select onChange={(e) => { setVenueType(e.target.value) }} className={"w-full bg-transparent text-gray-400"}>
                        <option>Futsal</option>
                              <option>Soccer</option>
                              <option>Badminton</option>
                        <option>Padel</option>
                      </select>
                    </div> */}

                    <div className='flex w-full justify-start'>
                      <input onChange={(e) => { setVenueName(e.target.value) }} value={venueName} type="text" className={inputClass + " text-xs "} placeholder='Input Nama Lapang' />
                    </div>

                    <div className='flex w-full justify-start '>
                      <textarea onChange={(e) => { setVenueDesc(e.target.value) }} value={venueDesc} className={textarea + " text-xs "} placeholder='Deskripsi Lapangan...' />
                    </div>


                  </div>

                  {/* detail lapangan part kanan */}
                  <div className='flex flex-col w-1/2 gap-y-6 '>

                    {/* <p className='text-sm font-semibold'>Detail Alamat Lapang</p> */}



                    <MapDialog onAddressConfirmed={(lat, lng, address) => { handleAddress(lat, lng, address) }} />

                    <textarea onChange={(e) => { setVenueAddress(e.target.value) }} value={venueAddress} className={textarea + " text-xs "} placeholder='Deskripsi Alamat Venue' />


                  </div>

                </div>

                {/* detail lapangan part kanan */}
                <p className='text-sm font-semibold my-4'>Jam Operational Lapangan</p>

                <div className='flex gap-x-6 '>

                  <DaySelectionDialog dayOpen={dayOpen} setDayOpen={setDayOpen} />
                  {/* <TimeSelectionDialog timeOpen={timeOpen} setTimeOpen={setTimeOpen} /> */}

                  <label className="relative  flex w-1/4 text-gray-400 focus-within:text-gray-600 ">
                    <ClockIcon className='w-6 bg-gray-400 p-1 rounded-lg absolute top-1/2 transform -translate-y-1/2 left-3 text-white' />
                    <InputMask
                      mask="99:99"
                      maskChar={null}
                      value={venueOpenHour}
                      onChange={(e) => { setVenueOpenHour(e.target.value) }}
                      placeholder="Jam Buka"
                      className={"pl-12 flex-grow text-xs " + inputClass}
                    >
                      {(inputProps) => <input type="text" {...inputProps} />}
                    </InputMask>
                  </label>

                  <label className="relative  flex w-1/4 text-gray-400 focus-within:text-gray-600 ">
                    <ClockIcon className='w-6 bg-gray-400 p-1 rounded-lg absolute top-1/2 transform -translate-y-1/2 left-3 text-white' />

                    <InputMask
                      mask="99:99"
                      maskChar={null}
                      value={venueCloseHour}
                      onChange={(e) => { setVenueCloseHour(e.target.value) }}
                      placeholder="Jam Tutup"
                      className={"pl-12 flex-grow text-xs " + inputClass}
                    >
                      {(inputProps) => <input type="text" {...inputProps} />}
                    </InputMask>

                  </label>

                </div>

              </div>

              {/* fasilitas lapang */}
              <div className='mt-4 relative flex flex-col border border-gray-300 rounded-lg px-8 pt-12 overflow-hidden'>
                <p className='absolute left-0 top-0 px-3 bg-gray-200 py-1.5 rounded-br-lg text-sm font-semibold '>Fasilitas Lapang</p>

                <ul className="grid grid-cols-1 w-full gap-4 sm:grid-cols-2 md:grid-cols-3" >
                  {addOnList.map((addOn) => (
                    <li key={addOn.id} value={addOn} onClick={(e) => { onAddOnSelected(addOn) }} >
                      <div
                        className={classNames(checkAddon(addOn) ? "bg-[#eff5ff] border-primaryRed " : " bg-white border-gray-300 "
                          , "rounded-lg hover:bg-[#eff5ff] text-[11px] font-semibold text-primaryRed flex items-center py-1.5 px-3 border ")}>
                        {/* <PlusCircleIcon className=' w-6 mr-2 ' /> */}
                        <img className={checkAddon(addOn) ? 'w-7 mr-2 bg-primaryRed rounded-full p-1' : 'w-7 mr-2 bg-[#cfcfcf] rounded-full p-1'} src={addOn.image} />
                        {addOn.name}
                      </div>
                    </li>
                  ))}
                </ul>

                {/* show attachments image  */}
                <div className='flex flex-wrap gap-4 my-6'>
                  {attachmentsUrl.map((url, index) => {
                    return (
                      <img key={index} src={url} className='h-16 rounded-lg' />
                    )
                  })}
                </div>

                <input ref={attachmentsRef} type="file" className="sr-only" onChange={onAttachmentChange} multiple />
                <div onClick={(e) => { handleAttachmentClick() }} className='flex w-1/2 cursor-pointer items-center bg-gray-100 rounded-lg px-2 py-1 mb-4'>
                  <p className='text-xs ml-2 flex-grow text-gray-700 font-semibold'>Upload Foto Lapang & Fasilitas</p>
                  <div className=' bg-gray-400 rounded-lg text-white'>
                    <ArrowUpOnSquareIcon className='w-6 p-1.5' />
                  </div>
                </div>

              </div>

              {/* kebijakan lapang  */}
              <div className='mt-4 relative flex  items-center border border-gray-300 rounded-lg overflow-hidden'>
                <p className='absolute left-0 top-0 px-3 bg-gray-200 py-1.5 rounded-br-lg text-sm font-semibold '>Kebijakan Lapang</p>

                <div className="flex flex-col flex-1 pt-14 pb-6 gap-y-4 px-8">
                  <p className="ml-1 text-xs font-semibold text-gray-800">Input Kebijakan Lapang</p>
                  <ReactQuill
                    className="flex flex-col h-[200px]"
                    value={venueTos}
                    onChange={setVenueTos}
                    theme="snow"
                  />

                </div>

              </div>



              <div className='w-full flex'>
                <button
                  onClick={() => { updateCompanyApi() }}
                  disabled={loading}
                  className={`cursor-pointer flex mt-4 w-fit items-center px-8 py-3 text-[10px] font-semibold text-white bg-primaryRed rounded-md ${loading ? 'opacity-75' : ''}`}
                >
                  {loading ? 'Loading' : (
                    <>
                      <img src='/ic_send.png' className='w-4 mr-2' />
                      Update Data
                    </>
                  )}
                </button>
              </div>

            </div>
          </Tab>
          <Tab label="Edit Profil">
            <div className="">
              <div className='flex flex-col lg:flex-row w-full lg:gap-x-5 gap-y-5'>

                <div className='lg:w-7/12 w-full flex flex-col gap-y-5 py-5 px-5 gap-y-5 '>
                  <div className='flex w-full flex-col gap-y-5'>
                    <input disabled={true} onChange={(e) => {
                      setUserData(prev => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }} value={userData.name} type="text" className={"w-1/2 text-[10px] " + inputClass} placeholder='Nama Administrator' />
                    <input disabled={true} onChange={(e) => {
                      setUserData(prev => ({
                        ...prev,
                        phone_number: e.target.value,
                      }))
                    }} value={userData.phone_number} type="text" className={"w-1/2 text-[10px] " + inputClass} placeholder='Nomor Telepon' />
                    <input disabled={true} onChange={(e) => {
                      setUserData(prev => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }} value={userData.email} type="text" className={"w-1/2 text-[10px] " + inputClass} placeholder='Alamat Email' />
                    <input onChange={(e) => {
                      setUserData(prev => ({
                        ...prev,
                        password: e.target.value,
                      }))
                    }} value={userData.password} type="password" className={"w-1/2 text-[10px] " + inputClass} placeholder='Password' />
                    <input onChange={(e) => {
                      setUserData(prev => ({
                        ...prev,
                        ulangi_password: e.target.value,
                      }))
                    }} value={userData.ulangi_password} type="password" className={"w-1/2 text-[10px] " + inputClass} placeholder='Ulangi Password' />
                  </div>
                </div>

              </div>

              <div className='w-full flex'>
                <button onClick={() => { updateUserAdmin() }} disabled={loading} className={`cursor-pointer flex mt-0 mb-4 ml-4 w-fit items-center px-8 py-3 text-[10px] font-semibold text-white bg-primaryRed rounded-md ${loading ? 'opacity-75' : ''}`}>
                  {loading ? 'Loading' : (
                    <>
                      <img src='/ic_send.png' className='w-4 mr-2' />
                      Simpan Data
                    </>
                  )}
                </button>
              </div>
            </div>
          </Tab>
          <Tab label="Akun Bank">
            <div className="">
              <div className='flex flex-col lg:flex-row w-full lg:gap-x-5 gap-y-5'>

                <div className='lg:w-7/12 w-full flex flex-col gap-y-5 py-5 px-5 gap-y-5 '>
                  <div className='flex w-full flex-col gap-y-5'>
                    <div className={'flex w-full text-xs bg-[#F5F5F5] rounded-md pr-2 focus:outline-none focus:border focus:border-primaryYellow focus:ring-1 focus:ring-primaryYellow'}>
                      <select className={"w-full appearance-none text-gray-700 flex w-1/2 text-[10px] " + inputClass} placeholder='Pilih Bank'
                        onChange={(e) => {
                          setProfile(prev => ({
                            ...prev,
                            bank: e.target.value,
                          }))
                        }} value={profile.bank}
                      >
                        <option value="BCA">BCA</option>
                        <option value="BRI">BRI</option>
                        <option value="Mandiri">Mandiri</option>
                      </select>
                      <img src='ic-caret-dropdown.svg' />
                    </div>
                    <input onChange={(e) => {
                      setProfile(prev => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }} value={profile.name} type="text" className={"w-1/2 text-[10px] " + inputClass} placeholder='Nama Pemilik Akun' />
                    <input onChange={(e) => {
                      setProfile(prev => ({
                        ...prev,
                        number: e.target.value,
                      }))
                    }} value={profile.number} type="text" className={"w-1/2 text-[10px] " + inputClass} placeholder='Nomor Rekening' />
                    <div className='flex'>
                      <img src='ic-round-info-button.svg' />
                      <p className='text-[10px] ml-2'>Dengan klik tombol di bawah, kamu menyetujui Syarat & Ketentuan<br />
                        serta Kebijakan Privasi untuk menambahkan rekening.</p>
                    </div>
                  </div>
                </div>

              </div>

              <div className='w-full flex'>
                <button onClick={() => { updateProfileApi() }} disabled={loading} className={`cursor-pointer flex mt-0 mb-5 ml-5 w-fit items-center px-8 py-3 text-[10px] font-semibold text-white bg-primaryRed rounded-md ${loading ? 'opacity-75' : ''}`}>
                  {loading ? 'Loading' : (
                    <>
                      <img src='/ic_send.png' className='w-4 mr-2' />
                      Simpan Data
                    </>
                  )}
                </button>
              </div>
            </div>
          </Tab>
        </Tabs>



      </div>
    </div>
  );
}